<template lang="html">
  <div>
    <v-overlay :value="!loaded">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-container
      fluid
      class="pa-0 ma-0"
    >
      <slot name="navigation" />
      <v-row>
        <v-col cols="12">
          <v-card class="mx-auto">
            <iframe
              v-show="loaded"
              ref="frame"
              loading="lazy"
              :src="event.embedded_file_path"
              width="100%"
              height="1000px"
              frameborder="0"
              allowfullscreen
              @load="load"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    props: {
      event: {
        type: Object,
        default: null,
      },     
    },
    data () {
      return {
        loaded: false,
      }
    },
    methods: {
      load () {
        this.loaded = true
      },
    },
  }
</script>
